import { Fieldset, SelectField } from '@servicetitan/anvil2-react-hook-form';
import { DriversLicenseFields } from './DriversLicenseFields';
import { MilitaryIDFields } from './MilitaryIDFields';
import { PassportFields } from './PassportFields';
import { StateIDFields } from './StateIDFields';
import { GreenCardFields } from './GreenCardFields';
import { VisaFields } from './VisaFields';
import { LoanApplicantIdDocumentType } from '@servicetitan/financing-api-client';
import { useFormContext } from 'react-hook-form';

interface ContainerProps {
    fieldPrefix?: string;
}

const idTypes = [
    {
        name: "Driver's License",
        value: LoanApplicantIdDocumentType.DriversLicense,
        component: DriversLicenseFields,
    },
    {
        name: 'Green Card',
        value: LoanApplicantIdDocumentType.UsaGreenCard,
        component: GreenCardFields,
    },
    {
        name: 'Military',
        value: LoanApplicantIdDocumentType.MilitaryId,
        component: MilitaryIDFields,
    },
    { name: 'Passport', value: LoanApplicantIdDocumentType.Passport, component: PassportFields },
    { name: 'State ID', value: LoanApplicantIdDocumentType.StateId, component: StateIDFields },
    { name: 'Visa', value: LoanApplicantIdDocumentType.Visa, component: VisaFields },
];

const idTypeOptions = idTypes.map(type => ({
    id: type.value,
    label: type.name,
}));

export const Container = ({ fieldPrefix = '' }: ContainerProps) => {
    const { watch } = useFormContext();
    const idType = watch([fieldPrefix, 'applicantId.applicantIdDocumentType'].join('.'));
    const IDFieldsComponent = (idTypes.find(type => type.value === idType) ?? idTypes[0]).component;
    return (
        <Fieldset legend="Identification">
            <SelectField
                name={[fieldPrefix, 'applicantId.applicantIdDocumentType'].join('.')}
                options={idTypeOptions}
                label="ID Type"
                required
            />
            {IDFieldsComponent != null ? <IDFieldsComponent fieldPrefix={fieldPrefix} /> : null}
        </Fieldset>
    );
};
